module.exports = __webpack_public_path__ + "static/product5-e-e2f4bcc9570391f888da4ba8353005e2.png";